import React from "react";

import { Container, Row, Col, Button } from "reactstrap";
import Countries from "./Countries";

import S8 from "./svgs/s8";
import S1 from "./svgs/s1";
import ScrollAnimation from "react-animate-on-scroll";
import Slider from "react-slick";
import { size } from "./common";
import S11 from "./svgs/s11";
import S7 from "./svgs/s7";

function Speaker({ speakers }) {
  const content = [
    {
      title: "Digital Disruption to Digital Domination",
      description:
        "Explore how the region’s financial institutions are progressing from digitization to building holistic, intelligent, and scalable digital-first ecosystems.",
      image: <S1 />,
    },
    {
      title: "Decentralized Finance & Tokenization",
      description:
        "Discover the growing impact of DeFi, digital currencies, and tokenized assets in reshaping capital flows, asset management, and customer access.",
      image: <S11 />,
    },
    {
      title: "Building CX That Thinks Like a Customer",
      description:
        "From data-driven insights to AI-powered personalization—this theme will explore how institutions are building empathy-driven, responsive digital journeys.",
      image: <S7 />,
    },
    {
      title: "Regulation as an Enabler",
      description:
        "Dive into the evolving regulatory landscape across the GCC—how central banks are enabling responsible innovation and secure adoption of emerging technologies.",
      image: <S8 />,
    },
  ];
  const content1 = [
    {
      title: "Insights That Matter",
      description:
        "Future-proof your digital strategy with ideas from regional CXOs, disruptors, and policymakers.",
    },
    {
      title: "Connections That Count",
      description: "Engage with a curated list of decision-makers ready to partner and co-create.",
    },
    {
      title: "Innovation That Performs",
      description: "Showcase your capabilities to the right audience, at the right time.",
    },
    {
      title: "Exclusive Roundtable Strategy Sessions",
      description:
        "Join exclusive, closed-door discussions with top financial executives to tackle Middle East’s biggest banking challenges and shape the future.",
    },
  ];

  const settings = {
    dots: true,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 3000,
    swipeToSlide: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 1,
    className: "p-10",
    customPaging: function (i) {
      return <div className="dot"></div>;
    },
    dotsClass: "slick-dots slick-thumb",
  };
  return (
    <>
      <div
        style={{
          backgroundColor: "transparent",

          overflow: "hidden",
        }}
        className="section py-3"
      >
        <Container
          fluid
          style={{
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top right",

            backgroundSize: "80%",
          }}
        >
          <Container className="py-2">
            <Row>
              <Col lg={12}>
                <h1
                  className=" text-700 pb-0 text-white mt-0 text-uppercase"
                  style={{ fontSize: size ? "2rem" : "1.5rem" }}
                >
                  <b>Middle East’s Fintech Metamorphosis —</b>
                </h1>
                <h1
                  className=" text-400 pb-0 text-white mt-0 text-uppercase"
                  style={{ fontSize: size ? "2rem" : "1.5rem" }}
                >
                  Digital, Decentralized & Disruptive
                </h1>
              </Col>
              <Col lg={6} md={6} sm={12} className="">
                <h5
                  className="text-400 text-white text-justify"
                  style={{
                    lineHeight: "30px",
                    color: "#010011",
                    textTransform: "none",
                  }}
                >
                  <br />
                  As the Middle East undergoes a radical transformation in finance, led by visionary
                  regulations, booming fintech ecosystems, and rising digital adoption, the region
                  is redefining its role in the global financial order. The convergence of
                  decentralized finance, open banking, digital currencies, and artificial
                  intelligence is crafting an entirely new blueprint for the financial world.
                  <br />
                  <br />
                  Finnovex Middle East 2025 returns to Dubai on November 11-12th to drive this
                  momentum forward. Join policymakers, regulators, banking leaders, central banks,
                  digital disruptors, and technology pioneers as they shape a next-gen financial
                  landscape powered by decentralization, AI, Web3, and hyper-personalized CX.
                  <br />
                  <br />
                </h5>
              </Col>
              <Col lg={6} className="mt-5 pr-0">
                {content.map((s, index) => (
                  <ScrollAnimation
                    animateIn={"fadeInUp"}
                    animateOnce={true}
                    duration={0.5 + index / 8}
                  >
                    <div className="py-4 px-2 stat-div mb-2" style={{ minHeight: 200 }}>
                      <div className="container-fluid row pr-0">
                        <Col className="align-self-center" xs={3}>
                          {s.image}
                        </Col>
                        <Col>
                          <h3
                            style={{
                              color: "#fff",
                              fontSize: size ? "18px" : "14px",
                            }}
                            className="text-700 mt-0"
                          >
                            {s.title}
                          </h3>
                          <h3
                            style={{
                              color: "#fff",
                              fontSize: size ? "16px" : "12px",
                            }}
                            className="text-400 mt-0"
                          >
                            {s.description}
                          </h3>
                        </Col>
                      </div>
                    </div>
                  </ScrollAnimation>
                ))}
              </Col>
            </Row>
          </Container>
          <Container>
            <Row>
              <Col lg={12}>
                <h3
                  style={{
                    color: "#fff",
                    fontSize: size ? "36px" : "20px",
                  }}
                  className="text-400 mt-0"
                >
                  Redefining Finance in the Middle East: Bold. Inclusive. Disruptive.
                </h3>
              </Col>
            </Row>
            <Slider {...settings}>
              {content1.map((data, i) => (
                <div className="d-flex w-100 my-5">
                  <Col lg={6} className="align-self-start">
                    <h3
                      style={{
                        color: "#fff",
                        fontSize: "36px",
                      }}
                      className="text-400 mt-0"
                    >
                      <i class="fa fa-quote-left text-primary" aria-hidden="true"></i>{" "}
                      <span className="pl-4 pr-4">{data.title}</span>
                      <i class="fa fa-quote-right text-primary" aria-hidden="true"></i>
                    </h3>
                    <h4 className="text-400 mt-5 text-white">{data.description}</h4>
                  </Col>
                  <Col lg={6} className="align-self-center">
                    <img src={require(`assets/quotes/${i + 5}.jpg`)} width="100%" alt="main logo" />
                  </Col>
                </div>
              ))}
            </Slider>
          </Container>

          <Countries />
          <Container>
            <Row className="justify-content-center">
              <Col lg={4} className="text-center">
                <Button
                  href="/register"
                  className="btn my-2 text-center px-5"
                  color="primary"
                  size="lg"
                  outline
                >
                  Register Now
                </Button>
              </Col>
            </Row>
          </Container>
          <Container className="py-5">
            <Row className="justify-content-center">
              {images.map((id, i) => (
                <Col lg={4} xs={12} key={i}>
                  <img
                    alt="..."
                    className=" img-responsive my-3"
                    width="100%"
                    src={require(`assets/images/photos/${id}`)}
                  />
                </Col>
              ))}
            </Row>
          </Container>
        </Container>
      </div>
    </>
  );
}

export default Speaker;

const images = [
  "DSC00068.jpg",
  "DSC00080.jpg",
  "DSC00097.jpg",
  "DSC00777.jpg",
  "DSC08476.jpg",
  "DSC08652.jpg",
  "DSC08667.jpg",
  "DSC08670.jpg",
  "DSC08711.jpg",
  "DSC08716.jpg",
  "DSC09944.jpg",
  "DSC09999.jpg",
];
